import React, { useState, useEffect } from "react";
import moment from "moment";

import { formatOptions } from "../../../service/common";
import {
  option_sex,
  option_treatment_type,
  option_treatment_consider,
  option_treatment_type_less,
  option_treatment_undo,
  option_control_type,
  option_control_consider,
  option_control_type_less,
  option_control_undo,
} from "../../../service/option";
import { word_setting } from "../../../service/word";

import { styles } from "./setting";

import { Page, Text, View, Document } from "@react-pdf/renderer";

export default function ModulePdfOutputMain(props) {
  const { pdfType, patientData = {} } = props;
  const [optionData, setOptionData] = useState({});
  const [step3Data, setStep3Data] = useState({
    5: { key: "step3_5", title: "非常在意(5分)", data: [] },
    4: { key: "step3_4", title: "十分在意(4分)", data: [] },
    0: { key: "step3_0", title: "在意程度未有達4分", data: [] },
  });
  const [step5Data, setStep5Data] = useState({
    1: { key: "step5_1", data: [] },
    2: { key: "step5_2", data: [] },
  });

  useEffect(() => {
    let temp = formatOptions({
      sex: option_sex,
      treatment_type: option_treatment_type,
      treatment_consider: option_treatment_consider,
      treatment_type_less: option_treatment_type_less,
      treatment_undo: option_treatment_undo,
      control_type: option_control_type,
      control_consider: option_control_consider,
      control_type_less: option_control_type_less,
      control_undo: option_control_undo,
    });

    setOptionData((state) => ({
      ...state,
      ...temp,
    }));
  }, []);

  useEffect(() => {
    if (Object.keys(optionData).length === 0) return;

    let temp3 = { ...step3Data };
    Object.values(patientData.formDetail.step3).forEach((item, index) => {
      temp3[item < 4 ? 0 : item].data.push(
        optionData[`${pdfType}_consider`][index]
      );
    });
    setStep3Data(temp3);

    let temp5 = { ...step5Data };
    patientData.formDetail.step5.d1.forEach((item) => {
      temp5[1].data.push(optionData[`${pdfType}_type_less_obj`][item]);
    });
    patientData.formDetail.step5.d2.forEach((item) => {
      temp5[2].data.push(optionData[`${pdfType}_undo_obj`][item]);
    });
    setStep5Data(temp5);
  }, [pdfType, optionData, patientData]);

  return (
    <>
      <Document>
        <Page
          size="A4"
          style={{
            ...styles.page,
            ...styles.font_size_10,
            ...styles.line_height_1,
          }}
        >
          <View
            style={{
              ...styles.w_9,
              ...styles.mb_2,
            }}
          >
            <Text
              style={{
                ...styles.font_size_18,
                ...styles.font_bold,
                ...styles.mb_2,
              }}
            >
              兒童近視治療共享決策輔助平台
            </Text>
            <Text
              style={{
                ...styles.w_355px,
                ...styles.font_size_14,
                ...styles.font_bold,
                ...styles.border,
                ...styles.px_1,
                ...styles.py_05,
              }}
            >
              {word_setting[pdfType]}
            </Text>
          </View>

          <View style={{ ...styles.mt_3 }}>
            <View>
              <Text style={{ ...styles.font_size_13, ...styles.font_bold }}>
                1. 小孩資料
              </Text>
            </View>
            <View
              style={{
                ...styles.flex,
                ...styles.aiCenter,
                ...styles.font_size_13,
                ...styles.ml_25,
                ...styles.mt_1,
              }}
            >
              <Text>性別 </Text>
              <View
                style={{
                  ...styles.w_30px,
                  ...styles.textCenter,
                  ...styles.borderBottom,
                }}
              >
                <Text>
                  {patientData.formUser?.ksex
                    ? optionData.sex_obj?.[patientData.formUser?.ksex]
                        ?.showLabel
                    : "-"}
                </Text>
              </View>
              <Text style={{ ...styles.ml_05 }}>，</Text>
              <View
                style={{
                  ...styles.w_30px,
                  ...styles.textCenter,
                  ...styles.borderBottom,
                }}
              >
                <Text>
                  {patientData.formUser?.birthday
                    ? Number(moment().format("YYYY")) -
                      Number(
                        moment(patientData.formUser?.birthday).format("YYYY")
                      )
                    : "-"}
                </Text>
              </View>
              <Text>歲，目前度數左眼 </Text>
              <View
                style={{
                  ...styles.w_40px,
                  ...styles.textCenter,
                  ...styles.borderBottom,
                }}
              >
                <Text>{patientData.formUser?.ldegree ?? "-"}</Text>
              </View>
              <Text>右眼 </Text>
              <View
                style={{
                  ...styles.w_40px,
                  ...styles.textCenter,
                  ...styles.borderBottom,
                }}
              >
                <Text>{patientData.formUser?.rdegree ?? "-"}</Text>
              </View>
              <Text>，眼軸左眼 </Text>
              <View
                style={{
                  ...styles.w_40px,
                  ...styles.textCenter,
                  ...styles.borderBottom,
                }}
              >
                <Text>{patientData.formUser?.laxis ?? "-"}</Text>
              </View>
              <Text>右眼 </Text>
              <View
                style={{
                  ...styles.w_40px,
                  ...styles.textCenter,
                  ...styles.borderBottom,
                }}
              >
                <Text>{patientData.formUser?.raxis ?? "-"}</Text>
              </View>
            </View>
          </View>

          <View style={{ ...styles.mt_3 }}>
            <View>
              <Text style={{ ...styles.font_size_13, ...styles.font_bold }}>
                2. 目前比較想要選擇的方式是
              </Text>
            </View>
            <View
              style={{
                ...styles.font_size_13,
                ...styles.ml_25,
                ...styles.mt_1,
              }}
            >
              {pdfType === "treatment" && (
                <Text>
                  {
                    optionData[`${pdfType}_type_obj`]?.[
                      patientData.formDetail.step2.a1
                    ]?.showLabel
                  }
                  {patientData.formDetail.step2.a1 === 10 && (
                    <>：{patientData.formDetail.step2.a2}</>
                  )}
                </Text>
              )}
              {pdfType === "control" &&
                patientData.formDetail.step2.a1.map((item) => (
                  <Text key={item} style={{ ...styles.mb_1 }}>
                    {optionData[`${pdfType}_type_obj`]?.[item]?.showLabel}
                    {item === 8 && <>：{patientData.formDetail.step2.a2}</>}
                  </Text>
                ))}
            </View>
          </View>

          <View style={{ ...styles.mt_3 }}>
            <View>
              <Text style={{ ...styles.font_size_13, ...styles.font_bold }}>
                3. 想要再瞭解更多的問題
              </Text>
            </View>
            <View
              style={{
                ...styles.font_size_13,
                ...styles.ml_25,
                ...styles.mt_1,
              }}
            >
              <Text>{patientData.formDetail.step2.a3}</Text>
            </View>
          </View>

          <View style={{ ...styles.mt_3 }}>
            <View>
              <Text style={{ ...styles.font_size_13, ...styles.font_bold }}>
                4. 對於醫療方式的考量?(4分 或 5分)
              </Text>
            </View>
            <View
              style={{
                ...styles.font_size_13,
                ...styles.w_9,
                ...styles.ml_25,
                ...styles.mt_1,
              }}
            >
              {Object.values(step3Data)
                .reverse()
                .map((typeData) => (
                  <React.Fragment key={typeData.key}>
                    {typeData.data.length > 0 && (
                      <View
                        style={{
                          ...styles.flex,
                          ...styles.aiCenter,
                          ...styles.flexWrap,
                        }}
                      >
                        <Text style={{ ...styles.font_bold }}>
                          {typeData.title}：
                        </Text>
                        {typeData.data.map((item, index) => (
                          <React.Fragment key={item.value}>
                            {index !== 0 && <Text>、</Text>}
                            <Text style={{ ...styles.borderBottom }}>
                              {item.label}
                            </Text>
                          </React.Fragment>
                        ))}
                      </View>
                    )}
                  </React.Fragment>
                ))}
            </View>
          </View>

          <View style={{ ...styles.mt_3 }}>
            <View>
              <Text style={{ ...styles.font_size_13, ...styles.font_bold }}>
                5. 閱讀網頁後的決定
              </Text>
            </View>
            <View
              style={{
                ...styles.font_size_13,
                ...styles.ml_25,
                ...styles.mt_1,
              }}
            >
              <View
                style={{
                  ...styles.flex,
                  ...styles.aiCenter,
                  ...styles.wFull,
                }}
              >
                <View
                  style={{
                    ...styles[
                      patientData.formDetail.step5.d1.length > 0
                        ? "checkbox_checked"
                        : "checkbox_sm"
                    ],
                  }}
                ></View>
                <Text
                  style={{
                    ...styles.ml_1,
                  }}
                >
                  已決定
                </Text>
              </View>
              {step5Data[1].data.length > 0 && (
                <View
                  style={{
                    ...styles.flex,
                    ...styles.aiCenter,
                    ...styles.flexWrap,
                    ...styles.ml_35,
                  }}
                >
                  {step5Data[1].data.map((item, index) => (
                    <React.Fragment key={item.value}>
                      {index !== 0 && <Text>、</Text>}
                      <Text>{item.label}</Text>
                    </React.Fragment>
                  ))}
                </View>
              )}
              <View
                style={{
                  ...styles.flex,
                  ...styles.aiCenter,
                  ...styles.wFull,
                  ...styles.mt_1,
                }}
              >
                <View
                  style={{
                    ...styles[
                      patientData.formDetail.step5.d2.length > 0
                        ? "checkbox_checked"
                        : "checkbox_sm"
                    ],
                  }}
                ></View>
                <Text
                  style={{
                    ...styles.ml_1,
                  }}
                >
                  未決定，原因：
                </Text>
              </View>
              {step5Data[2].data.length > 0 && (
                <View
                  style={{
                    ...styles.flex,
                    ...styles.aiCenter,
                    ...styles.flexWrap,
                    ...styles.ml_35,
                  }}
                >
                  {step5Data[2].data.map((item, index) => (
                    <React.Fragment key={item.value}>
                      {index !== 0 && <Text>、</Text>}
                      <Text>
                        {item.label}
                        {item.value === 3
                          ? `(${patientData.formDetail.step5.d3})`
                          : ""}
                      </Text>
                    </React.Fragment>
                  ))}
                </View>
              )}
            </View>
          </View>

          <View
            style={{
              ...styles.fixedBottom,
              ...styles.font_size_10,
              ...styles.textRight,
              ...styles.w_9,
            }}
          >
            <View>
              <Text>
                兒童近視治療共享決策平台 -國科會專題研究計畫
                MOST111-2314-B-255-004-MY3 版權所有
              </Text>
            </View>
            <View>
              <Text>長庚學校財團法人長庚科技大學護理系</Text>
            </View>
          </View>
        </Page>
      </Document>
    </>
  );
}
